const OPEN_DELAY = {bottom: 5000, center: 2000};

function initPopup(wrapper: HTMLElement): void {
    const popup = wrapper.querySelector<HTMLElement>('.custom-popup');
    const toggle = wrapper.querySelector<HTMLButtonElement>('.custom-popup--toggle');

    if (!popup || !toggle) return;

    const key = `custom_popup_${wrapper.dataset.popup}`;
    const position = wrapper.classList.contains('position-center') ? 'center' : 'bottom';
    let timeout: ReturnType<typeof setTimeout> | undefined;

    const setOpen = (open: boolean) => {
        clearTimeout(timeout);
        popup.classList.toggle('open', open);
        toggle.setAttribute('aria-expanded', String(open));

        try {
            open ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, '1');
        } catch {
            // ignore storage errors
        }
    };

    wrapper.hidden = false;
    toggle.addEventListener('click', () => setOpen(!popup.classList.contains('open')));
    wrapper.querySelector('.custom-popup--close')?.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && popup.classList.contains('open')) setOpen(false);
    });

    let dismissed = false;

    try {
        dismissed = sessionStorage.getItem(key) !== null;
    } catch {
        // ignore storage errors
    }

    if (!dismissed) {
        timeout = setTimeout(() => setOpen(true), OPEN_DELAY[position]);
    }
}

window.addEventListener('load', () => {
    const now = Date.now() / 1000;
    const active = [...document.querySelectorAll<HTMLElement>('.custom-popup-wrapper')].find(({dataset}) => {
        const start = Number(dataset.start);
        const end = Number(dataset.end);

        return start <= now && (!end || now < end);
    });

    if (active) initPopup(active);
});
